module.exports = __webpack_public_path__ + "img/galleria-original-480.16f24d6c.webp";